import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '@m43/core';
import { ApiResultPreferencesView, PreferenceOption } from '@mark43/cad-api';
import { ApiResult } from '@mark43/cad-api';
import { PreferencesResource } from '@mark43/cad-api';
import { AxiosError, AxiosResponse } from 'axios-cad-nx';

export type SavePreferencesSuccessData = AxiosResponse<ApiResultPreferencesView>;
export type SavePreferencesError = AxiosError<ApiResult>;

interface UseSavePreferencesProps {
    onSuccess?: (data: SavePreferencesSuccessData) => void;
    onError?: (error: SavePreferencesError) => void;
}

export const useSavePreferences = ({ onSuccess, onError }: UseSavePreferencesProps) => {
    const apiClient = useApiClient();

    const { mutate: savePreferences } = useMutation({
        mutationFn: (preference: Omit<PreferenceOption, 'label'>) => {
            return apiClient.request<PreferencesResource.UpsertUserPreferences>({
                method: 'POST',
                url: 'preferences/user/',
                data: {
                    //TODO: `label` is required per typing, but sending it does nothing anyway.  We should update the api to
                    //      not require it.
                    preferenceOptions: [{ ...preference, label: '' }],
                },
            });
        },
        onError: (e: SavePreferencesError) => {
            onError?.(e);
        },
        onSuccess: (data: SavePreferencesSuccessData) => {
            onSuccess?.(data);
        },
    });

    return savePreferences;
};
